"use client"

import { BadgeJapaneseYen } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `BadgeJapaneseYenIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const BadgeJapaneseYenIcon = component(Icon)({ as: BadgeJapaneseYen })
